import { Component } from 'react';
import { connect } from 'react-redux';

import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { bindActionCreators } from 'redux';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import { twMerge } from 'tailwind-merge';
import { DataDisplayType, OpenModal, PortType, PositionType, RootState, SwitchType, TrackType, UserType } from 'types';
import { MainControlsInterface, MapControlsInterface, MenuControlsInterface } from 'types/functions';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { findNearestPointInTime } from 'utils/drawing';
import { checkDifferent, clone } from 'utils/formHandlers';
import { findBestData } from 'utils/migrations';
import { hasPermission } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface VesselToolTipStaticProps {
    //unused props
    outlineInterval: number;
    //unused props
    mainControls: MainControlsInterface;

    menuControls: MenuControlsInterface;
    mapControls: MapControlsInterface;
    currentTime: DateTimeFormat | null;
    mode: string;
    port: PortType;

    //unused props
    dateTimeFormat: DateTimeFormat;

    //unused props
    openModelFunction: OpenModal;

    //unused props
    setOutlineIntervalAction: (outlineInterval: number) => void;

    switchs: SwitchType;
    user: UserType;
}

interface VesselToolTipStaticState {
    track: TrackType | null;
    dataDisplay: DataDisplayType;
    position: PositionType | null;
    loading: boolean;
    switchs: SwitchType;
    currentTime: DateTimeFormat | null;
    analysisVariables: any;
}

class VesselToolTipStatic extends Component<VesselToolTipStaticProps, VesselToolTipStaticState> {
    constructor(props: VesselToolTipStaticProps) {
        super(props);
        this.state = {
            currentTime: props.currentTime,
            dataDisplay: props.port.meta_data.dataDisplay,
            position: null,
            track: null,
            loading: true,
            switchs: clone(props.switchs),
            analysisVariables: props.port.meta_data.analysisVariables,
        };
    }

    static getDerivedStateFromProps(props: VesselToolTipStaticProps, state: VesselToolTipStaticState) {
        if (props.currentTime?.toTimestamp() != state.currentTime?.toTimestamp()) {
            return { currentTime: props.currentTime };
        }

        if (checkDifferent(props.switchs, state.switchs, true)) {
            return {
                switchs: clone(props.switchs),
            };
        }

        return null;
    }

    componentDidMount(): void {
        this.loadTrackData();
    }

    componentDidUpdate(prevProps: VesselToolTipStaticProps, prevState: VesselToolTipStaticState) {
        if (prevState.currentTime?.toTimestamp() != this.state.currentTime?.toTimestamp()) {
            this.loadTrackData();
        }
    }

    loadTrackData = () => {
        const track =
            this.props.mode === 'playback'
                ? //@ts-ignore
                  this.props.menuControls.playback?.getTrackMainTrack()
                : //@ts-ignore
                  this.props.menuControls.time?.getTrack();
        console.log(track);
        if (!track) {
            return;
        }
        const { data } = findBestData(track?.data, null, this.state.currentTime);
        this.setState({
            loading: false,
            //@ts-ignore
            track: track,
            position:
                this.props.mode === 'playback'
                    ? //@ts-ignore
                      findNearestPointInTime(data, null, this.state.currentTime)
                    : //@ts-ignore
                      this.props.menuControls.time.getBestPosition(this.state.toolTip?.data.parent, null, null, {
                          //@ts-ignore
                          east_utm: this.state.toolTip?.east_utm,
                          //@ts-ignore
                          north_utm: this.state.toolTip?.north_utm,
                      }),
        });
    };

    getDisplay = (type: string, key: string) => {
        const dataDisplay = this.state?.dataDisplay;

        if (dataDisplay?.[type]?.[key]) {
            return dataDisplay[type][key];
        }

        return {};
    };

    displayValue = (value, group = 'transit') => {
        if (!this.state.position) {
            return '-';
        }

        if (this.state.position[value] === 'N/A') {
            return 'N/A';
        }

        return `${parseFloat(
            //@ts-ignore
            this.state.position[value] * this.getDisplay(group, value).database2display_unit_factor
        ).toFixed(this.getDisplay(group, value).decimal)}${this.getDisplay(group, value).unit}`;
    };

    render() {
        return (
            <div className="  bg-white no-select  flex flex-col w-staticTooltip   overflow-hidden rounded-md">
                {this.state.loading ? (
                    <LoaderSpinner className="my-10 mx-20" variant="button"></LoaderSpinner>
                ) : (
                    <div className="w-full flex flex-col p-2">
                        <div className=" gap-x-2 items-start capitalize">
                            <span
                                className={twclsx(
                                    (!hasPermission(this.props.user, this.props.port.id, ['identifyTransits']) ||
                                        !this.state.switchs.identifyTransits.value) &&
                                        'blurText',
                                    'capitalize',
                                    'font-bold'
                                )}
                            >
                                {this.state.track?.vessel.name}{' '}
                            </span>
                            ({translate(this.state.track?.vessel.vessel_category.label)})
                        </div>

                        <div className="flex-1 w-full truncate">
                            <div className="flex justify-between items-start">
                                <div className="  items-center   ">
                                    <h3 className="text-activeGray text-sm leading-5 font-medium truncate">
                                        {this.state.track?.vessel.loa_m}
                                        {this.getDisplay('vessel', 'loa_m').unit} x {this.state.track?.vessel.beam_m}
                                        {this.getDisplay('vessel', 'beam_m').unit} (
                                        {this.displayValue('draft_m', 'vessel')}
                                         )
                                    </h3>
                                    <p
                                        className={twMerge(
                                            this.state.position?.valid_time_utc &&
                                                this.props?.currentTime &&
                                                this.state.position?.valid_time_utc?.getDiffInSeconds(
                                                    this.props?.currentTime
                                                ) <
                                                    (this.state.position?.navigational_status_id === 5 ||
                                                    this.state.position?.navigational_status_id === 1
                                                        ? this.state.analysisVariables?.aisDataDropoutMoored_seconds
                                                        : this.state.analysisVariables?.aisDataDropoutUnderway_seconds)
                                                ? ' text-red-500'
                                                : ' text-gray-500',
                                            'mb-1',
                                            'text-sm',
                                            'font-bold',
                                            'leading-4',
                                            'truncate'
                                        )}
                                    >
                                        <span
                                            className={twclsx(
                                                (!hasPermission(this.props.user, this.props.port.id, [
                                                    'identifyTransits',
                                                ]) ||
                                                    !this.state.switchs.identifyTransits.value) &&
                                                    'blurText'
                                            )}
                                        >
                                            {this.state.position?.valid_time_utc.formatDateTimeToString('dd LLL yyyy')}
                                        </span>
                                        <span className="ml-1">
                                            {this.state.position?.valid_time_utc.formatDateTimeToString('HH:mm:ss Z')}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="h-px w-full bg-gray-300 my-1"></div>
                            {this.state.switchs.playbackManoeuvreInformationOnRightColumn?.value && (
                                <div className="py-1  text-sm  ">
                                    <div className="flex justify-between items-center  ">
                                        <div>
                                            <div className="flex justify-start items-center gap-2 mr-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'heading_deg').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('heading_deg')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 mr-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'cog_deg').name} :
                                                    </span>
                                                    <span className="text-black">{this.displayValue('cog_deg')}</span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 mr-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'drift_angle_deg').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('drift_angle_deg')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="flex justify-start items-center gap-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'sog_mps').name} :
                                                    </span>
                                                    <span className="text-black">{this.displayValue('sog_mps')}</span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'rot_deg_min').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('rot_deg_min')}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="flex justify-start items-center gap-2 ">
                                                <div className="font-bold">
                                                    <span className="text-gray-600">
                                                        {this.getDisplay('transit', 'crot_deg_min').name} :
                                                    </span>
                                                    <span className="text-black">
                                                        {this.displayValue('crot_deg_min')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const vesselToolTipStaticStateToProps = (state: RootState) => ({
    outlineInterval: state.map.outlineInterval,
    switchs: state.layout.switchs,
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    mainControls: state.layout.mainControls,
    menuControls: state.layout.menuControls,
    mapControls: state.map.mapControls,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const vesselToolTipStaticDispatchToProps = (dispatch: any) => ({
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
});

export default connect(vesselToolTipStaticStateToProps, vesselToolTipStaticDispatchToProps)(VesselToolTipStatic);
